import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { map, tap } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { CalcType } from '../lookups/CalcType';
import { IGenericResponse } from '../shared';
import { LoadingService } from '../shared/loading';
import { LoggingService } from '../shared/services/logging/logging.service';
import * as fromRoot from '../store';
import { IndirectRateCostCenter } from './store/indirect-rate-cost-center';
import { IndirectRateRule } from './store/indirect-rate-rule';
import { IndirectRateStructure } from './store/indirect-rate-structure';
@Injectable({
    providedIn: 'root'
})
export class IndirectRateService extends LoadingService {
    private uri = `${environment.apiLocation}/IndirectRate`;
    private indirectRateTypeUri = `${environment.apiLocation}/IndirectRateType`;
    private indirectRateCostCenterUri = `${environment.apiLocation}/IndirectRateCostCenter`;
    private indirectRateRuleUri = `${environment.apiLocation}/IndirectRateRule`;

    constructor(
        private http: HttpClient,
        protected log: LoggingService,
        protected rootStore: Store<fromRoot.CoreState>
    ) {
        super(rootStore);
    }

    public post(params: {
        FYenddate: string;
        Ratetype?: string;
    }): Observable<IndirectRateStructure[]> {
        super.Load();
        return this.http.post<IndirectRateStructure[]>(this.uri, params).pipe(
            tap(data => {
                super.Stop();
                this.log.verbose({
                    type: 'IndirectRateService:post',
                    data
                });
            }),
            map(rates =>
                rates.map(x => ({
                    ...x,
                    id: this.getIndirectRateStructureId(x)
                }))
            )
        );
    }
    public put(
        items: IndirectRateStructure[]
    ): Observable<IGenericResponse<IndirectRateStructure>> {
        // return getTestServiceError<IndirectRateStructure>(20, items as IndirectRateStructure[], 'id');
        this.log.verbose({
            type: 'IndirectRateService:put',
            items
        });
        return this.http
            .put<IGenericResponse<IndirectRateStructure>>(this.uri, {
                IndirectRateList: items
            })
            .pipe(
                tap(resp =>
                    this.log.verbose({
                        type: 'IndirectRateService:response',
                        resp
                    })
                ),
                map(resp => ({
                    ...resp,
                    Items: resp.Items.map(x => ({
                        ...x,
                        id: this.getIndirectRateStructureId(x)
                    }))
                }))
            );
    }
    public delete(items): Observable<IGenericResponse<IndirectRateStructure>> {
        // return getTestServiceError<IndirectRateStructure>(20, items as IndirectRateStructure[], 'id');
        return this.put(items.map(x => ({ ...x, Ratepercent: 0 })));
        // return this.http.request<IGenericResponse<IndirectRateStructure>>(
        //     'DELETE',
        //     this.uri,
        //     {
        //         body: { EntityIDs: [...items.map(x => x.id)] }
        //     }
        // );
    }
    public getIndirectRateTypes(): Observable<CalcType[]> {
        super.Load();
        return this.http.get<CalcType[]>(this.indirectRateTypeUri).pipe(
            tap(data => {
                super.Stop();
                this.log.verbose({
                    type: 'IndirectRateService:getIndirectRateTypes',
                    data
                });
            })
        );
    }
    public getIndirectRateCostCenters(): Observable<IndirectRateCostCenter[]> {
        super.Load();
        return this.http
            .get<IndirectRateCostCenter[]>(this.indirectRateCostCenterUri)
            .pipe(
                tap(data => {
                    super.Stop();
                    this.log.verbose({
                        type: 'IndirectRateService:getIndirectRateCostCenters',
                        data
                    });
                }),
                map(rates =>
                    rates.map(x => ({
                        ...x,
                        id: x.Costcenterid
                    }))
                )
            );
    }
    public putIndirectRateCostCenters(
        items: IndirectRateCostCenter[]
    ): Observable<IGenericResponse<IndirectRateCostCenter>> {
        // return getTestServiceError<IndirectRateCostCenter>(20, items as IndirectRateCostCenter[], 'id');
        return this.http
            .put<IGenericResponse<IndirectRateCostCenter>>(
                this.indirectRateCostCenterUri,
                {
                    IndirectRateCostCenterList: items
                }
            )
            .pipe(
                tap(data => {
                    super.Stop();
                    this.log.verbose({
                        type: 'IndirectRateService:getIndirectRateCostCenters',
                        data
                    });
                }),
                map(resp => ({
                    ...resp,
                    Items: resp.Items.map(x => ({
                        ...x,
                        id: x.Costcenterid
                    }))
                }))
            );
    }
    public getIndirectRateRules(
        rateType: string,
        costCenter: number
    ): Observable<IndirectRateRule[]> {
        this.log.verbose({
            type: 'IndirectRateService:getIndirectRateRules',
            rateType,
            costCenter
        });
        super.Load();
        return this.http
            .post<IndirectRateRule[]>(this.indirectRateRuleUri, {
                Calctype: rateType,
                Costcenterid: costCenter
            })
            .pipe(
                tap(data => {
                    super.Stop();
                    this.log.verbose({
                        type: 'IndirectRateService:getIndirectRateRules',
                        data
                    });
                }),
                map(rates =>
                    rates.map(x => ({
                        ...x,
                        id: this.getIndirectRateRuleId(x)
                    }))
                )
            );
    }
    private getIndirectRateStructureId(item: IndirectRateStructure) {
        return `${item.Costcenterid}${item.Calctype}`;
    }
    private getIndirectRateRuleId(item: IndirectRateRule) {
        return `${item.Costcenterid}-${item.Calctype}-${item.Ratecomponent}`;
    }
}
